import React from 'react';
import './Mission.css';
import { mission } from '../../../constants';
import { Heading } from '../../../components';



const OurMission = () => {
    return (
        <section className="our-mission">
            <div className="box-container">
                <div className="content">
                    <div className="text">

                        {/* Section Heading */}
                        <Heading title={mission.heading} subTitle={mission.sub} linear />

                        {/* Mission Content */}
                        <p>{mission.content}</p>

                        {/* Mission Key Points List */}
                        <ul className="mission-section-points">
                            {mission.points.map(point => (
                                <li key={point.id}>
                                    <div className='icon'>{point.icon}</div> {/* Mission point Icon */}
                                    <div className="text">
                                        <h5>{point.title}</h5> {/* Mission point Title */}
                                        <p>{point.content}</p> {/* Mission point Description*/}
                                    </div>
                                </li>
                            ))}
                        </ul>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurMission;